export default {
  methods: {
    getType(name) {
      if (name != undefined) {
        let res = name.split("-");
        return res[0];
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/formRender/reusable/getType.js